import { NavigationGuardNext, Route } from 'vue-router';
import ApiServiceWrapper from './../api-request.service';
import * as decode from 'jwt-decode';
import store from '@/store/store';
import { AppStore } from '@/store';
import { currentUserKey } from '../msw-constants';
import { Dictionary } from 'vue-router/types/router';
import { envCongif } from '../env.config';
import _ from 'lodash';

class MswAccountService {
  storeT: AppStore;
  BASE_URL: string = '/workspace';

  constructor() {
    this.storeT = store;
  }

  public async checkIfAccountWorkflow() {
    let isaccountsmswredirect = 'NO';
    try {
      const response = await ApiServiceWrapper.get('version')
        .then((response: any) => {
          if (response.operationStatus === 'OK') {
            return response?.content?.isaccountsmswredirect || 'NO';
          }
          return 'NO';
        })
        .catch((e: any) => {
          throw new Error(e);
        });
      isaccountsmswredirect = response || 'NO';
    } catch (e) {
      isaccountsmswredirect = 'NO';
      console.error(e);
    } finally {
      localStorage.setItem('isaccountsmswredirect', JSON.stringify(isaccountsmswredirect));
    }
  }

  /* tslint:disable: no-unused */
  public async redirection(to: Route, from: Route, next: NavigationGuardNext) {
    await this.checkIfAccountWorkflow();
    if (this.checkIfParameterHasCode()) {
      this.exchangeCodeForToken(to, from, next);
    } else if (this.checkIfDemoSpogUser(to)) {
      next();
    } else if (await this.checkConditionsForAccountWorkrflow()) {
      this.navigateToAccounts(to, from, next);
    } else if (this.checkIfIDPWorkflow()) {
      if (window.location.hash) {
        const url = `${envCongif.api_url}/extAuth?code=${window.btoa(window.location.hash)}`;
        window.location.replace(url);
      }
    } else {
      next();
    }
  }

  public async checkConditionsForAccountWorkrflow() {
    const queryParams = new URLSearchParams(location.search);
    const isaccountmswredirectRow: any = localStorage.getItem('isaccountsmswredirect');
    const isaccountsmswredirect: string = JSON.parse(isaccountmswredirectRow) || 'NO';
    return (
      !queryParams.has('CODE') &&
      isaccountsmswredirect === 'YES' &&
      !this.checkIfLocalhost() &&
      !queryParams.has('token') &&
      !queryParams.has('custviewtok') &&
      !(queryParams.has('MODE') && queryParams.get('MODE') === 'APP') &&
      !(queryParams.has('embed') && queryParams.get('embed') === 'YES')
    );
  }

  public async checkToken() {
    const currentUser: any = localStorage.getItem(currentUserKey);
    const parsedToken = currentUser && JSON.parse(currentUser);
    const token = parsedToken?.token || '';
    if (token !== '') return true;
    if (token) {
      const decodedToken: any = decode(token);
      let response: boolean = false;
      if (Math.floor(+new Date() / 1000) < decodedToken.exp) {
        try {
          response = await ApiServiceWrapper.get('users/get-landing-applications')
            .then((response: any) => {
              if (response.operationStatus === 'OK') {
                return true;
              }
              return false;
            })
            .catch((e: any) => {
              throw new Error(e);
            });
        } catch (e) {
          console.error(e);
          response = false;
        }
      }
      return response;
    }
    return false;
  }

  public checkIfParameterHasCode() {
    const queryParams = new URLSearchParams(location.search);
    const isaccountmswredirectRow: any = localStorage.getItem('isaccountsmswredirect');
    const isaccountsmswredirect: string = JSON.parse(isaccountmswredirectRow) || 'NO';
    return (
      !this.checkIfLocalhost() &&
      !queryParams.has('custviewtok') &&
      (queryParams.has('CODE') || queryParams.has('code'))
    );
  }

  /* tslint:disable: no-unused */
  public async exchangeCodeForToken(to: Route, from: Route, next: NavigationGuardNext) {
    if (to?.query?.CODE || to?.query?.code) {
      try {
        const accessCode: string =
          (to?.query?.CODE && to?.query?.CODE.toString()) ||
          (to?.query?.code && to?.query?.code.toString()) ||
          '';
        const decodedAccessCode = window.decodeURIComponent(accessCode.toString()) || '';
        this.storeT.commit('startLoading');
        const response = await this.storeT.dispatch('exchangeCodeForToken', {
          accessCode: decodedAccessCode,
        });
        if (response) {
          if (response.operationStatus === 'NOK') {
            throw new Error(`${response.msgDesc || 'Api Response is NOK'}`);
          }
          this.storeT.commit('stopLoading');
          if (response.operationStatus === 'OK') {
            const value: any = response.content.token || '';
            const decodedResponse: any = (value && decode(value)) || {};
            const res: any = {
              msgCode: '',
              msgDesc: '',
              content: {
                deviceCode: '',
                defaultApplication: '',
                isFreeTrial: '',
                userName: decodedResponse?.userName,
                emailAddress: decodedResponse?.email,
                givenName: decodedResponse?.givenName,
                token: response?.content?.token,
                sId: decodedResponse.sId,
                TFA: '',
                roles: decodedResponse.roles?.split(','),
                showRegisterPopup: '',
                spogUser: '',
                refreshToken: response?.content?.refreshtoken,
              },
              showRememberMe: '',
            };
            decodedResponse.isLargeCustomer === 'YES'
              ? localStorage.setItem('isLargeCustomer', 'YES')
              : localStorage.setItem('isLargeCustomer', 'NO');
            // preserveUserInfo(res);
            this.storeT.dispatch('preserveUserInfo', res);
            this.storeT.commit('mutate', {
              property: 'isGuestBuyNowUser',
              with: false,
            });
            if (decodedResponse.showPendo && decodedResponse.showPendo !== '') {
              localStorage.setItem('showPendo', decodedResponse.showPendo);
            }
            this.storeT.commit('mutate', { property: 'loggedIn', with: true });
            this.navigateToDashboard(to, from, next);
          } else {
            console.error(response.msgDesc);
            this.navigateToAccounts(to, from, next);
          }
        }
      } catch (e) {
        console.error(e);
        this.navigateToAccounts(to, from, next);
      }
    }
  }
  /* tslint:disable: no-unused */
  public navigateToAccounts(to: Route, from: Route, next: NavigationGuardNext) {
    this.refreshLocalForage();
    let redirectURL: string = window.location.origin.toString();
    let redirectPage: string = '';
    if (Reflect.has(to.query, 'redirectUrl')) {
      redirectPage = to.query.redirectUrl.toString() || '';
    }
    if (Reflect.has(to.query, 'accountLogOut')) {
      if (to.query.accountLogOut && to.query.accountLogOut === 'YES') {
        if (to.query.mode && to.query.mode === 'logoutAll') {
          window.location.href = `${envCongif.accounts_url}/?logout=TRUE`;
        } else {
          window.location.href = `${envCongif.accounts_url}/dashboard`;
        }
        return;
      }
    }
    let url = `${envCongif.accounts_url}/?RESPONSETYPE=TOKEN`;
    if (window.location.pathname.indexOf('spog') > -1) {
      url += '&CLIENTID=GMSB5C64F1SPOG&REDIRECTURL=';
      redirectURL += '/muir/spog/login';
    } else {
      url += '&CLIENTID=MUIR1XHIS27&REDIRECTURL=';
      redirectURL += `${this.BASE_URL}/m/login/login-view`;
    }
    try {
      window.location.href =
        url +
        window.encodeURIComponent(redirectURL) +
        (redirectPage ? `&REDIRECTPAGE=${redirectPage}` : '');
    } catch (e) {
      console.error(e);
    }
  }

  private checkIfLocalhost() {
    return window.location.href.toString()
    .includes('localhost') ? true : false;
    // return false;
  }
  /* tslint:disable: no-unused */
  public navigateToDashboard(to: Route, from: Route, next: NavigationGuardNext) {
    let reDirectPage: string = '';
    if (to?.query?.REDIRECTPAGE) {
      reDirectPage = `${envCongif.msw_url}/workspace${window.atob(window.decodeURIComponent(to.query.REDIRECTPAGE.toString()))}` || '';
    } else if (to?.path === '/muir/spog/login') {
      reDirectPage = `${envCongif.msw_url}/workspace/m/feature/spog-homepage`;
    } else {
      reDirectPage = `${envCongif.msw_url}/workspace/m/feature/dashboard`;
    }
    const { path = '', query: queryParams = {} } = this.getDirectPage(reDirectPage);
    next({
      path,
      query: { ...queryParams, ...this.queryParametersTobeFiltered(to.query) } || {},
    });
  }

  private async refreshLocalForage() {
    try {
      localStorage.removeItem('custviewtok');
      localStorage.removeItem('currentUser');
    } catch (e) {
      console.error(e);
    }
  }

  checkIfDemoSpogUser(to: Route) {
    return (
      to.query.showdemo &&
      to.query.showdemo.toString() === 'yes' &&
      to.fullPath.includes('spog/login')
    );
  }

  /* This function is to check, if IDP login exists when accounts msw direction is disabled */
  private checkIfIDPWorkflow() {
    const isaccountmswredirectRow: any = localStorage.getItem('isaccountsmswredirect');
    const isaccountsmswredirect: string = JSON.parse(isaccountmswredirectRow) || 'NO';
    return (
      (window.location.hash &&
        window.location.hash !== '' &&
        isaccountsmswredirect === 'NO') ||
      false
    );
  }

  private getDirectPage(
    reDirectPage: string,
  ): {
    path?: string;
    query?: Dictionary<string | (string | null)[] | null | undefined>;
  } {
    if (!reDirectPage) {
      console.error('Redirect Page is empty');
      return { path: '', query: {} };
    }
    const pathName: string = new URL(reDirectPage)?.pathname || '';
    const redirectQuery: string = new URL(reDirectPage)?.search?.replace('?', '') || '';
    return {
      path: (pathName && pathName.replace(this.BASE_URL, '')) || '',
      query: { ...this.modifyQueryStringToObject(redirectQuery) },
    };
  }

  private queryParametersTobeFiltered(queries: any) {
    if (!queries) return {};
    if (_.isEmpty(queries)) return {};
    const filteredQueries: any = {};
    const rejectedQueries: string[] = ['code', 'CODE', 'REDIRECTPAGE'];
    for (const key in queries) {
      if (!rejectedQueries.includes(key)) {
        filteredQueries[key] = queries[key];
      }
    }
    return filteredQueries;
  }

  private modifyQueryStringToObject(redirectQuery: string) {
    if (redirectQuery === '') return {};
    const queries = redirectQuery.split('&');
    let modifyQueries = {};
    queries.forEach((query: any) => {
      const [key, value] = query.split('=');
      modifyQueries = {
        ...modifyQueries,
        [key]: value,
      };
    });
    return modifyQueries;
  }
}

export default new MswAccountService();
